import React from "react";
import useSWR from "swr";
import fetcher, { METHODS } from "./services/fetcher";
import fetch from "unfetch";
import { useParams, useHistory } from "react-router-dom";
import { useForm, ErrorMessage } from "react-hook-form";
import { DateUtils } from "react-day-picker";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Input from "./components/Input";
import InputDatePicker from "./components/InputDatePicker";
import Message from "./components/Message";
import DragAndDrop from "./components/DragAndDrop";
import Checkbox from "./components/Checkbox";

// ヽ(。_°)ノ
const dateRegEx = /((0[13578]|1[02])[/]31[/](18|19|20)[0-9]{2})|((01|0[3-9]|1[1-2])[/](29|30)[/](18|19|20)[0-9]{2})|((0[1-9]|1[0-2])[/](0[1-9]|1[0-9]|2[0-8])[/](18|19|20)[0-9]{2})|((02)[/]29[/](((18|19|20)(04|08|[2468][048]|[13579][26]))|2000))/i;

export default function Checkout() {
  const { uuid, contractNumber } = useParams();
  const history = useHistory();

  const uploadRef = React.createRef();

  const {
    register,
    handleSubmit,
    setValue,
    errors,
    clearError,
    getValues,
    watch,
  } = useForm();

  const [serverResponse, setServerResponse] = React.useState();
  const [recentHotelInfo, setRecentHotelInfo] = React.useState({});

  const [folioSelected, setFolioSelected] = React.useState();
  const [saving, setSaving] = React.useState(false);

  const { data: hotelInfo = {} } = useSWR(
    `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}`,
    fetcher,
    {
      errorRetryCount: 1,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const { data: guestInfo = {} } = useSWR(
    `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}/contracts/${contractNumber}`,
    fetcher,
    {
      errorRetryCount: 1,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  React.useEffect(() => {
    if (Object.keys(hotelInfo).length) {
      setRecentHotelInfo(hotelInfo);
    }
  }, [hotelInfo]);

  const values = getValues();
  // const watchGuestNotFound = watch("guest_not_found", false);
  const watchNoShow = watch("no_show", false);
  const watchCancelRes = watch("cancel_reservation", false);
  // const total = watch("customer_total", guestInfo.customer_total);

  const checkoutEarlierThanToday = DateUtils.isDayBefore(
    new Date(values.check_out || guestInfo.check_out),
    new Date()
  );

  const disable = () => {
    if (guestInfo.pending_update && checkoutEarlierThanToday) {
      return false;
    } else if (guestInfo.pending_update) {
      return true;
    }
    return false;
  };
  // ) ||
  // DateUtils.isSameDay(
  //   new Date(values.check_out || guestInfo.check_out),
  //   new Date()
  // );

  const encodings = {
    "+": "",
    "!": "",
    '"': "",
    "#": "",
    $: "",
    "&": "",
    "'": "",
    "(": "",
    ")": "",
    "*": "",
    ",": "",
    ":": "",
    ";": "",
    "=": "",
    "?": "",
    "@": "",
  };

  const sanitize = (name) =>
    name
      .replace(
        /(\+|!|"|#|\$|&|'|\(|\)|\*|\+|,|:|;|=|\?|@)/gim,
        (match) => encodings[match]
      )
      .replace(/\s/g, "");

  const uploadFolio = async () => {
    const folioName = `${contractNumber}-${sanitize(folioSelected.name)}`;
    const { url } = await fetcher(
      `${process.env.REACT_APP_SIGNED_URL_HOST}/upload`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-amz-meta-filekey": folioName,
        },
      }
    );

    if (url) {
      const done = await fetch(url, {
        method: METHODS.PUT,
        headers: {
          "content-type": "multipart/form-data",
        },
        body: folioSelected,
      });

      if (done.ok) return `${process.env.REACT_APP_FOLIO_HOST}/${folioName}`;
      return;
    }
  };

  const onSubmit = async (data) => {
    console.log(`data: `, data);
    setSaving(true);
    const folio_url = data.folio && (await uploadFolio());
    const folioDetails = {
      ...data,
      total_cost_of_stay: data.cancel_reservation ? "0" : data.customer_total,
      check_in: new Date(data.check_in).toISOString(),
      check_out: new Date(data.check_out).toISOString(),
      folio_url,
      finalized: checkoutEarlierThanToday || data.no_show,
    };

    try {
      fetcher(
        `${process.env.REACT_APP_HE_API_HOST}/hotel_partners/${uuid}/contracts/${contractNumber}/folio_details`,
        METHODS.POST,
        folioDetails
      ).then((d) => {
        // setRecentData(d);
        setServerResponse({
          type: "Success",
          message: "Form successfully submitted",
        });

        setTimeout(() => {
          history.push(`/hotel_partners/${uuid}/contracts`);
        }, 1005);

        // setSaving(false);
      });
    } catch (error) {
      setServerResponse({ type: "Error", message: error.message });
    }
  };

  const handleUpload = async (e) => {
    if (e.target.files && e.target.files.length) {
      setValue("folio", e.target.files[0].name);
      setFolioSelected(e.target.files[0]);
    }
  };

  const handleDrop = (files) => {
    setValue("folio", files[0].name);
    setFolioSelected(files[0]);
  };

  const handleRemoveFolio = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setValue("folio", undefined);
    setFolioSelected(undefined);
    uploadRef.current.value = "";
  };

  const handleCheckbox = (e) => {
    setValue(e.target.name, e.target.checked);
    if (e.target.name === "no_show") {
      setValue("cancel_reservation", false);
    }
    if (e.target.name === "cancel_reservation") {
      setValue("no_show", false);
    }
  };

  const folioRequired = () => {
    if (watchCancelRes) return false;

    // if (watchNoShow && guestInfo.state === "visiting") {
    //   return false;
    // }

    // if (watchNoShow && total > 0 && checkoutEarlierThanToday) {
    //   return true;
    // }

    if (watchNoShow) return true;

    return true;
  };

  return (
    <div className="flex flex-col container mx-auto items-center mt-4">
      <Header {...recentHotelInfo} readOnly guestInfo={guestInfo} />
      <form
        className="w-full max-w-2xl lg:max-w-3xl shadow p-4 bg-white relative"
        onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <InputDatePicker
              label="Actual Check In"
              name="check_in"
              register={register({
                required: true,
                pattern: {
                  value: dateRegEx,
                  message: "Please select a date or use MM/DD/YYYY format",
                },
              })}
              value={guestInfo.check_in}
              disabledDay={values.check_out || guestInfo.check_out}
              disabledOperator="after"
              clearError={clearError}
              errors={errors}
              disabled={disable()}
            />
          </div>
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <InputDatePicker
              label="Actual Check Out"
              name="check_out"
              register={register({
                required: true,
                pattern: {
                  value: dateRegEx,
                  message: "Please select a date or use MM/DD/YYYY format",
                },
              })}
              value={guestInfo.check_out}
              disabledDay={values.check_in || guestInfo.check_in}
              clearError={clearError}
              errors={errors}
              disabled={disable()}
            />
          </div>
        </div>
        {(checkoutEarlierThanToday ||
          guestInfo.state === "completed" ||
          guestInfo.state === "cancelled" ||
          watchNoShow) && (
          <div className="flex flex-wrap md:-mx-3 mb-4">
            <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
              <Input
                startAdornment={() => (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ top: "0.95rem", left: "1rem" }}
                    className="absolute text-gray-500">
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                  </svg>
                )}
                label="Total Cost of Stay"
                name="customer_total"
                value={watchCancelRes ? "0" : guestInfo.customer_total}
                forceUpdate={watchCancelRes}
                type="number"
                placeholder={0}
                ref={register({ required: true })}
                errors={errors}
                disabled={disable() || watchCancelRes}
              />
            </div>
            <div className="w-full md:w-1/2 px-3">
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Upload Folio
              </label>
              <DragAndDrop onDrop={handleDrop}>
                <div className="flex relative overflow-hidden cursor-pointer">
                  <input
                    type="text"
                    name="folio"
                    className={`z-0 cursor-pointer appearance-none block w-full bg-gray-200 text-gray-700 border truncate ${
                      errors.folio ? "border-red-500" : "border-gray-200"
                    } rounded rounded-r-none py-3 pl-4 pr-6 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
                    placeholder="Select or drag and drop file"
                    ref={register({
                      required: folioRequired(),
                    })}
                    disabled
                  />
                  {folioSelected && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ right: 70, top: "0.95rem" }}
                      className="absolute right-0 text-gray-800 z-20"
                      onClick={handleRemoveFolio}>
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="15" y1="9" x2="9" y2="15"></line>
                      <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                  )}
                  <div className="flex -mr-px">
                    <span className="flex items-center bg-blue-500 rounded rounded-l-none border border-blue-500 text-white py-2 px-4">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="">
                        <polyline points="16 16 12 12 8 16"></polyline>
                        <line x1="12" y1="12" x2="12" y2="21"></line>
                        <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>
                        <polyline points="16 16 12 12 8 16"></polyline>
                      </svg>
                    </span>
                  </div>
                  <input
                    ref={uploadRef}
                    type="file"
                    className="absolute opacity-0 top-0 left-0 h-full w-full cursor-pointer z-10"
                    onChange={handleUpload}
                    disabled={disable()}
                  />
                </div>
              </DragAndDrop>
              {errors.folio ? (
                <ErrorMessage
                  errors={errors}
                  name="folio"
                  message="Please fill out this field"
                  as="p"
                  className="text-red-500 text-xs italic"
                />
              ) : (
                <p style={{ height: 18 }}></p>
              )}
            </div>
          </div>
        )}
        <div className="flex flex-wrap md:-mx-3 mb-4">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            {/* <Checkbox
              name="guest_not_found"
              label="Guest did not stay here"
              disabled={disable()}
              ref={register({ required: false })}
            /> */}
            <Checkbox
              name="no_show"
              label="No Show"
              checked={values.no_show || false}
              disabled={disable()}
              onChange={handleCheckbox}
              ref={register({ required: false })}
            />
          </div>
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Checkbox
              name="cancel_reservation"
              label="Cancel Reservation"
              checked={values.cancel_reservation || false}
              onChange={handleCheckbox}
              disabled={disable()}
              ref={register({ required: false })}
            />
            {/* {(checkoutEarlierThanToday ||
              guestInfo.state === "completed" ||
              guestInfo.state === "cancelled") && (
              <Checkbox
                name="finalized"
                label="Finalize Reservation"
                disabled={disable()}
                ref={register({ required: false })}
              />
            )} */}
          </div>
        </div>
        <hr className="mb-8" />
        <div className="flex flex-wrap md:-mx-3 mb-4 items-center">
          <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
            <Input
              label="Your name"
              name="hotel_user"
              type="text"
              placeholder="Jane Doe"
              ref={register({ required: true })}
              errors={errors}
              disabled={disable()}
            />
          </div>
          <div className="flex justify-end w-full md:w-1/2 px-3">
            <button
              className={`shadow ${
                disable()
                  ? "bg-blue-800 pointer-events-none"
                  : "bg-blue-500 hover:bg-blue-400"
              } focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded mt-2`}
              style={{ height: 46 }}
              disabled={disable() || saving}
              type="submit">
              {saving
                ? "Processing..."
                : disable()
                ? "Pending Update"
                : watchNoShow || checkoutEarlierThanToday || watchCancelRes
                ? "Confirm Checkout"
                : "Update Reservation"}
            </button>
          </div>
        </div>
        {serverResponse && (
          <Message
            type={serverResponse.type}
            message={serverResponse.message}
            reset={() => setServerResponse()}
          />
        )}
      </form>
      <Footer />
    </div>
  );
}
